import { reduceErrors } from '../errors';

import { ETSY, SHOPIFY } from '../../constants/channels';
import { EMPTY } from '../../constants';
import { ERROR } from '../../constants/product';
import { FORM } from '../../constants/forms';
import ATTRIBUTE from '../../constants/attributes';

export function formHasErrors({ product, type }) {
  switch (type) {
    case FORM.DESCRIPTION: {
      return product.hasIn([FORM.DESCRIPTION, ERROR]);
    }

    case FORM.PHOTOS: {
      return product.hasIn([FORM.PHOTOS, ERROR]);
    }

    case FORM.TAGS: {
      return product.hasIn([FORM.TAGS, ERROR]);
    }

    case FORM.TITLE: {
      return product.hasIn([FORM.TITLE, ERROR]);
    }

    default: {
      break;
    }
  }

  switch (product.get('channel')) {
    case ETSY: {
      switch (type) {
        case FORM.DETAILS: {
          return (
            product.hasIn([FORM.DETAILS, ATTRIBUTE.CATEGORY, ERROR]) ||
            product.hasIn([FORM.DETAILS, ATTRIBUTE.IS_SUPPLY, ERROR]) ||
            product.hasIn([FORM.DETAILS, ATTRIBUTE.PRODUCTION_PARTNERS, ERROR]) ||
            product.hasIn([FORM.DETAILS, ATTRIBUTE.TAXONOMY_ATTRIBUTES, ERROR]) ||
            product.hasIn([FORM.DETAILS, ATTRIBUTE.WHEN_MADE, ERROR]) ||
            product.hasIn([FORM.DETAILS, ATTRIBUTE.WHO_MADE, ERROR])
          );
        }

        case FORM.FILES: {
          return product.hasIn([FORM.FILES, ERROR]);
        }

        case FORM.INVENTORY: {
          return (
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.QUANTITY, ERROR]) ||
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.SKU, ERROR])
          );
        }

        case FORM.PERSONALIZATION: {
          return (
            product.hasIn([FORM.PERSONALIZATION, ATTRIBUTE.CHAR_COUNT_MAX, ERROR]) ||
            product.hasIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, ERROR])
          );
        }

        case FORM.PRICING: {
          return product.hasIn([FORM.INVENTORY, ATTRIBUTE.PRICE, ERROR]);
        }

        case FORM.SHIPPING: {
          return (
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.HEIGHT, ERROR]) ||
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.LENGTH, ERROR]) ||
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.PROFILE_ID, ERROR]) ||
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.WEIGHT, ERROR]) ||
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.WIDTH, ERROR]) ||
            product.hasIn([FORM.SHIPPING, ATTRIBUTE.RETURN_POLICY, ERROR])
          );
        }

        case FORM.VARIATIONS: {
          return (
            !!product.getIn([FORM.DETAILS, ATTRIBUTE.CATEGORY, ERROR]) ||
            reduceErrors(product.getIn([FORM.VARIATIONS, ERROR], EMPTY.MAP))
          );
        }

        default: {
          return false;
        }
      }
    }

    case SHOPIFY: {
      switch (type) {
        case FORM.INVENTORY: {
          return (
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.BARCODE, ERROR]) ||
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.QUANTITY, ERROR]) ||
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.SKU, ERROR])
          );
        }

        case FORM.PRICING: {
          return (
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.CAP, ERROR]) ||
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.CPI, ERROR]) ||
            product.hasIn([FORM.INVENTORY, ATTRIBUTE.PRICE, ERROR])
          );
        }

        case FORM.SHIPPING: {
          return product.hasIn([FORM.INVENTORY, ATTRIBUTE.WEIGHT, ERROR]);
        }

        case FORM.VARIATIONS: {
          return reduceErrors(product.getIn([FORM.VARIATIONS, ERROR], EMPTY.MAP));
        }

        default: {
          return false;
        }
      }
    }

    default: {
      return false;
    }
  }
}
